import React, { useState, ChangeEvent, KeyboardEvent } from 'react';
import SearchBox from 'components/common/SearchBox';
import { faqs } from 'data/faq';
import { Accordion } from 'react-bootstrap';
import FaqCta from 'components/cta/FaqCta';
import classNames from 'classnames';

const FaqAccordion = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const filteredFaqs = faqs.filter(
    faq =>
      faq.title.toLowerCase().includes(searchQuery) ||
      faq.details.toLowerCase().includes(searchQuery)
  );

  return (
    <div>
      <h2 className="mb-5">FAQ</h2>
      <h5 className="mb-3">How can we help?</h5>
      <p className="text-body-tertiary">
        Search for the topic you need help with
      </p>
      <SearchBox
        placeholder="Search"
        className="w-100 mb-8"
        style={{ maxWidth: '25rem' }}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
      />
      <Accordion className="" defaultActiveKey="0">
        {filteredFaqs.map((faq, index) => (
          <Accordion.Item
            className={classNames({
              'border-top': index === 0
            })}
            eventKey={String(index)}
            key={faq.id}
          >
            <div className="form-label px-0">{faq.subtitle}</div>
            <Accordion.Header>{faq.title}</Accordion.Header>
            <Accordion.Body
              className="pt-0"
              dangerouslySetInnerHTML={{ __html: faq.details }}
            />
          </Accordion.Item>
        ))}
      </Accordion>
      <FaqCta />
    </div>
  );
};

export default FaqAccordion;
